//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { computed, ref } from '@vue/composition-api'

export default {
  setup() {
    const textfieldValue = ref('')

    const progress = computed(() => Math.min(100, textfieldValue.value.length * 10))

    const color = computed(() => ['error', 'warning', 'success'][Math.floor(progress.value / 40)])

    return {
      textfieldValue,
      progress,
      color,
    }
  },
}
